<template>
  <div class="deposit-table">
    <v-data-table
      :items="items"
      :loading="loading"
      class="rounded mb-2 elevation-1"
      disable-pagination
      hide-default-footer
      :headers="headers">
      <template v-slot:top>
        <v-toolbar flat class="rounded">
          <v-toolbar-title>Пункты</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="create"
          >
            Добавить
          </v-btn>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item, index }">
        <v-btn
          icon
          class="buttonUp"
          title="поставить раньше"
          @click="moveItem(item, 'up')"
          :disabled="index === 0"
        >
          <v-icon small> mdi-arrow-up-thin-circle-outline </v-icon>
        </v-btn>
        <v-btn
          icon
          class="buttonDown"
          title="поставить позже"
          @click="moveItem(item, 'down')"
          :disabled="index === items.length - 1"
        >
          <v-icon small> mdi-arrow-down-thin-circle-outline </v-icon>
        </v-btn>
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="checkRemove(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Удаление</span>
        </v-card-title>
        <v-card-text>
          Вы действительно хотите удалить этот пункт? Данное действие необратимо!
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">
            Отмена
          </v-btn>
          <v-btn color="blue darken-1" text @click="remove">
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DepositTable",
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      headers: [
        {
          text: "Название",
          align: "start",
          sortable: false,
          value: "title_ru"
        },
        { text: "Действия", value: "actions", align: "end", sortable: false }
      ],
      deleteDialog: false,
      deleteItem: null,
    }
  },
  methods:{
    create(){
      this.$emit('create');
    },
    editItem(point) {
      this.$emit('edit', point);
    },
    checkRemove(point) {
      this.deleteItem = point;
      this.deleteDialog = true;
    },
    moveItem(point, dir) {
      this.$emit('move', point, dir);
    },
    remove() {
      this.$emit('remove', this.deleteItem);
      this.deleteDialog = false;
    },
  }
}
</script>

<style lang="scss">
  .deposit-table tbody tr:first-child .buttonUp,
  .deposit-table tbody tr:last-child .buttonDown{
    visibility: hidden;
  }
</style>
